import { render, staticRenderFns } from "./add-exercises.vue?vue&type=template&id=45b0c852&"
import script from "./add-exercises.vue?vue&type=script&lang=js&"
export * from "./add-exercises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports